module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/right-giftset@2x_413f33.png";